/**
 * Custom Match Height Module
 * Registry Pattern for auto-refresh on resize
 * Supports dynamic content via MutationObserver
 */
(function (window) {
    var registry = [];
    var resizeTimeout;

    /**
     * Main function to calculate and set max height
     * @param {HTMLElement|jQuery} container 
     * @param {String} selector 
     */
    function setHeight(container, selector) {
        if (!container) return;
        var $msgContainer = $(container);

        // Safety check if container is still in DOM
        if ($msgContainer.length === 0 && container !== document) return;

        var $elements = $msgContainer.find(selector);
        if ($elements.length <= 1) {
            $elements.css({
                'height': 'auto',
                'min-height': '0'
            });
            return;
        }

        // 1. Reset to auto to get natural height
        $elements.css({
            'height': 'auto',
            'min-height': '0'
        });

        // 2. Group by Offset Top (Row Detection)
        var rows = {};

        $elements.each(function () {
            var $el = $(this);
            // Use integer offset to avoid sub-pixel float discrepancies
            var top = Math.floor($el.offset().top);

            // Allow small tolerance for alignment issues (1-2px)
            // We search for an existing row key that is close enough
            var rowKey = Object.keys(rows).find(key => Math.abs(key - top) <= 2);

            if (!rowKey) {
                rowKey = top;
                rows[rowKey] = [];
            }
            rows[rowKey].push($el);
        });

        // 3. Process each row
        Object.keys(rows).forEach(function (key) {
            var rowElements = rows[key];
            var maxHeight = 0;

            // Find max height in this row
            rowElements.forEach(function ($el) {
                // Use outerHeight for accuracy
                var h = $el.outerHeight();
                if (h > maxHeight) maxHeight = h;
            });

            // Apply min-height to all elements in this row
            if (maxHeight > 0) {
                rowElements.forEach(function ($el) {
                    $el.css('min-height', maxHeight + 'px');
                });
            }
        });
    }

    window.CustomMatchHeight = {
        /**
         * Register a new group using a specific container
         * @param {String|HTMLElement} containerSelector - Selector ID or class for the parent container
         * @param {String} itemSelector - Selector for the items to match height
         */
        register: function (containerSelector, itemSelector) {
            var containers;
            if (typeof containerSelector === 'string') {
                containers = document.querySelectorAll(containerSelector);
            } else if (containerSelector instanceof HTMLElement) {
                containers = [containerSelector];
            } else if (containerSelector instanceof NodeList) {
                containers = containerSelector;
            } else {
                return;
            }

            Array.from(containers).forEach(function (container) {
                // Avoid duplicates per container
                var exists = registry.some(r => r.container === container && r.selector === itemSelector);
                if (exists) return;

                var entry = {
                    container: container,
                    selector: itemSelector,
                    observer: null
                };
                registry.push(entry);

                // Initial calculation
                setHeight(container, itemSelector);

                // Setup Observer for dynamic content
                this.observe(entry);
            }, this);
        },

        observe: function (entry) {
            if (entry.observer) return;

            // Debounced update function for observer
            var debouncedUpdate = (function () {
                var timeout;
                return function () {
                    clearTimeout(timeout);
                    timeout = setTimeout(function () {
                        setHeight(entry.container, entry.selector);
                    }, 100);
                };
            })();

            var Observer = window.MutationObserver || window.WebKitMutationObserver;
            if (Observer) {
                entry.observer = new Observer(function (mutations) {
                    // Check if relevant nodes were added/removed/modified
                    var shouldUpdate = false;
                    for (var i = 0; i < mutations.length; i++) {
                        if (mutations[i].addedNodes.length > 0 || mutations[i].removedNodes.length > 0) {
                            shouldUpdate = true;
                            break;
                        }
                    }

                    if (shouldUpdate) {
                        debouncedUpdate();
                    }
                });

                entry.observer.observe(entry.container, {
                    childList: true,
                    subtree: true
                });
            }
        },

        update: function (container, selector) {
            setHeight(container, selector);
        },

        updateAll: function () {
            registry.forEach(function (item) {
                if (document.body.contains(item.container)) {
                    setHeight(item.container, item.selector);
                }
            });
        }
    };

    // Auto-refresh on resize
    $(window).on('resize orientationchange', function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function () {
            window.CustomMatchHeight.updateAll();
        }, 250);
    });

    // Re-run on collection ajax reload (standard theme event)
    document.addEventListener('collection:reloaded', function () {
        setTimeout(function () {
            window.CustomMatchHeight.updateAll();
        }, 100);
    });

    // Shopify specialized events (if any)
    document.addEventListener('shopify:section:load', function () {
        window.CustomMatchHeight.updateAll();
    });

})(window);
